// linkPreviewUtils.js
export const findImage = (metaTags, fallbackImage, setAltText) => {
    const imageExtensions = /\.(jpeg|jpg|gif|png|svg|ico)$/i;
    // Función para validar una URL
    const isValidUrl = (url) => {
        try {
            new URL(url);
            return true;
        } catch (error) {
            return false;
        }
    };

    // Buscar en metaTags la URL de la imagen preferida en el orden de prioridad deseado.
    if (
        metaTags["og:image"] &&
        metaTags["og:image"] !== "#" &&
        isValidUrl(metaTags["og:image"])
    ) {
        setAltText("OG image");
        return metaTags["og:image"];
    }
    if (
        metaTags["twitter:image"] &&
        metaTags["twitter:image"] !== "#" &&
        isValidUrl(metaTags["twitter:image"])
    ) {
        setAltText("Twitter image");
        return metaTags["twitter:image"];
    }

    // Buscar en el objeto anidado 'icons'
    if (metaTags.icons) {
        if (
            metaTags.icons["apple-touch-icon"] &&
            metaTags.icons["apple-touch-icon"] !== "#" &&
            isValidUrl(metaTags.icons["apple-touch-icon"]) &&
            imageExtensions.test(metaTags.icons["apple-touch-icon"])
        ) {
            setAltText("Apple Touch Icon");
            return metaTags.icons["apple-touch-icon"];
        }
        if (
            metaTags.icons["icon"] &&
            metaTags.icons["icon"] !== "#" &&
            isValidUrl(metaTags.icons["icon"]) &&
            imageExtensions.test(metaTags.icons["icon"])
        ) {
            setAltText("Icon");
            return metaTags.icons["icon"];
        }
    }

    if (
        metaTags["msapplication-TileImage"] &&
        metaTags["msapplication-TileImage"] !== "#" &&
        isValidUrl(metaTags["msapplication-TileImage"])
    ) {
        setAltText("MS Tile image");
        return metaTags["msapplication-TileImage"];
    }
    if (
        metaTags.favicon &&
        metaTags.favicon !== "#" &&
        isValidUrl(metaTags.favicon) && imageExtensions.test(metaTags.favicon)
    ) {
        setAltText("FavIcon image");
        return metaTags["favicon"];
    }

    // Si ninguna de las anteriores funciona, y tenemos un fallback válido, lo usamos.
    if (isValidUrl(fallbackImage)) {
        setAltText("Fallback image");
        return fallbackImage;
    }

    // Si no se encontró ninguna imagen y el fallback no es válido, devolver null
    return null;
};
